// extracted by mini-css-extract-plugin
export var section = "cr_d";
export var sectionHeader = "cr_jL";
export var sectionsWrapper = "cr_jK";